import React from 'react';
import { Box, Text } from '@chakra-ui/react';

const Banner1: React.FC = () => {
  return (
    <Box
      position="relative"
      width="100%"
      height="300px"
      backgroundImage="url('/family.png')"
      backgroundSize="cover"
      backgroundPosition="center"
      display="flex"
      alignItems="center"
      justifyContent="center"
    >
      {/* Dark overlay */}
      <Box
        position="absolute"
        top={0}
        left={0}
        width="100%"
        height="100%"
        bg="blackAlpha.500" 
        zIndex={1}
      />

      {/* Text content */}
      <Text
        fontSize="50px"
        color="white"
        fontWeight="bold"
        zIndex={2} 
      >
        Book Now
      </Text>
    </Box>
  );
};

export default Banner1;
